import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Rubric } from "@/types/rubric";
import { Label } from "@radix-ui/react-label";

interface RubricCriteriaSelectorProps {
  rubric: Rubric;
  selectedCriteriaId: string | null;
  onCriteriaSelect: (criteriaId: string) => void;
  onClear?: () => void;
}

export const RubricCriteriaSelector = ({
  rubric,
  selectedCriteriaId,
  onCriteriaSelect,
  onClear,
}: RubricCriteriaSelectorProps) => {
  return (
    <div className="flex items-center gap-2">
      <Label className="text-xs pr-2">Rubric:</Label>
      <Select
        value={selectedCriteriaId || "none"}
        onValueChange={(value) => {
          if (value === "none" && onClear) {
            onClear();
          } else {
            onCriteriaSelect(value);
          }
        }}
      >
        <SelectTrigger className="text-xs py-0 !h-[28px]">
          <SelectValue placeholder="None" className="py-0 text-xs h-[14px]" />
        </SelectTrigger>
        <SelectContent className="text-sm py-0">
          {onClear && <SelectItem value="none">None</SelectItem>}
          {rubric.criteria.map((criteria) => (
            <SelectItem key={criteria.id} value={criteria.id}>
              {criteria.criteria}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
